const UserType = {
    ClientUser: 'ROLE_CLIENT_USER',
    CustomerUser: 'ROLE_CUSTOMER_USER',
    SuperAdmin: 'ROLE_SUPER_ADMIN',
    CleintAdmin: 'ROLE_CLIENT_ADMIN',
    CustomerAdmin: 'ROLE_CUSTOMER_ADMIN',
}

export default UserType;